"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCompact = exports.formatSigned = exports.plainTwo = exports.plainOne = exports.plainInt = exports.formatRate = exports.formatTwo = exports.formatOne = exports.formatInt = void 0;
const n0 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const n1 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });
const n2 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });
const n4 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 4 });
/** Thin spaces instead of commas, the way the printed figures read. */
const spaced = (value) => value.replace(/,/g, " ");
const formatInt = (value) => spaced(n0.format(value));
exports.formatInt = formatInt;
const formatOne = (value) => spaced(n1.format(value));
exports.formatOne = formatOne;
const formatTwo = (value) => spaced(n2.format(value));
exports.formatTwo = formatTwo;
/** FX needs its full precision on a printed record, or the figures cannot be reproduced. */
const formatRate = (value) => spaced(n4.format(value));
exports.formatRate = formatRate;
/** Plain integer, no thin spaces — for the email summary. */
const plainInt = (value) => n0.format(value);
exports.plainInt = plainInt;
const plainOne = (value) => n1.format(value);
exports.plainOne = plainOne;
const plainTwo = (value) => n2.format(value);
exports.plainTwo = plainTwo;
/** Signed ledger amount, e.g. "+254 657" or "−555 000". */
const formatSigned = (value) => (value < 0 ? "−" : "+") + spaced(n0.format(Math.abs(value)));
exports.formatSigned = formatSigned;
/** Compact money, e.g. "$557k" or "−$1.24m". */
const formatCompact = (value) => {
    const abs = Math.abs(value);
    const sign = value < 0 ? "−$" : "$";
    if (abs >= 1e6)
        return sign + n2.format(abs / 1e6) + "m";
    if (abs >= 1e4)
        return sign + n0.format(abs / 1e3) + "k";
    if (abs >= 1e3)
        return sign + n1.format(abs / 1e3) + "k";
    return sign + n0.format(abs);
};
exports.formatCompact = formatCompact;
